








































import {
  computed,
  defineComponent,
  onBeforeMount,
  reactive,
  SetupContext,
} from '@vue/composition-api';
import { EntityType } from '@/store/entityModules/types';
import EntityTable from '@/components/common/EntityTable.vue';
import { getEntityStorePath } from '@/store/entityModules/utils';
import { DEFAULT_FILTER_VALUE } from '@/utils/constants';

const Component = defineComponent({
  name: 'ProductionTimeTable',

  components: {
    EntityTable,
  },

  setup(props: any, { root: { $store } }: SetupContext) {
    const entityType = EntityType.PRODUCTION_TIME;

    const categoryStorePath = getEntityStorePath(EntityType.CATEGORY);

    onBeforeMount(async () => {
      $store.dispatch(`${categoryStorePath}/setSearchHeaders`, [
        { text: 'name', value: 'name' },
      ]);
      $store.dispatch(`${categoryStorePath}/setQueryFiltering`, {
        filterBy: 'parentCategory',
        filterValue: DEFAULT_FILTER_VALUE,
      });
      $store.dispatch(`${categoryStorePath}/setOptions`, [
        {
          name: 'noProductionTime',
          value: true,
        },
      ]);
      $store.dispatch(`${categoryStorePath}/fetchItems`);
    });

    const state = reactive({
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Categories', value: 'categories', sortable: false, editable: true },
        { text: 'Details', value: 'actions', align: 'right', sortable: false },
      ],
      noProdTimeCategories: computed(() => $store.getters[`${categoryStorePath}/items`]),
    });

    return {
      entityType,
      state,
    };
  },
});
export default Component;
